import {Shape99InfoLine, Formes, CoteForme, FavoriteShape, FavoriteShapeStatus} from './json-interface';
import { CUtilit } from './utilit';
import { g_params } from './global-param';
import { CALC_VISIBILITY_COTE } from './const';
import {ArmaServConnection} from './info-connection';
import {HttpClient} from '@angular/common/http';
import {Point2D, Point3D} from './geometry';

export class CCalcForme {

  public mPathShapeDesc: Path2D[];
  public mCalculatedCodeF?: string;
  public mInterfaceForme?: Formes;
  public mDecalageX: number; // ???? // A garder si on ne veux pas center la forme sinon les cote ne seront pas bien callé sur le trcé de la forme
  public mScaleShapeX: number;
  public mScaleShapeY: number;
  public mScaleCotation: Point2D;
  public mStretchDrawing: boolean; // Définit si on étir le dessins dans le canvans ou que l'on ajuste de facin identique les X & Y
  public mCenterInCanvas: boolean; // Definit si l'on veux que l'image soit au centre du canvas donnée
  public mCanvasHeight: number;
  public mCanvasWidth: number;
  public mComments: string[];      // Commentaires de la forme
  public mCommentPos: Point2D[];     // Position des comentaires de la forme

  public static CreateFromForme(forme: Formes | undefined,
                                canvas: HTMLCanvasElement,
                                stretch: boolean = true,
                                centerInCanvas: boolean = true): CCalcForme {
    const ratioXY = CCalcForme.calculRatioShape(canvas, stretch);         // Calcule le ration X & Y pour le dessin de la forme
    const scaleCotation = CCalcForme.getScaleCotation(canvas, stretch);   // Calcule le ration X & Y pour le dessin des cotation
    return new CCalcForme(ratioXY, scaleCotation, stretch, centerInCanvas, canvas.height, canvas.width, forme);
  }

  private constructor(scaleShape: Point2D,
                      scaleCotation: Point2D,
                      stretch: boolean,
                      centerInCanvas: boolean,
                      canvasHeight: number,
                      canvasWidth: number,
                      forme: Formes | undefined) {
    this.mPathShapeDesc = [];
    this.mScaleShapeX = scaleShape.X;
    this.mScaleShapeY = scaleShape.Y;
    this.mScaleCotation = scaleCotation;
    this.mDecalageX = (CUtilForme.CST_DECALAGE_X_DESSIN_ARMAOR * scaleShape.X); // ????
    this.mComments = [];
    this.mCommentPos = [];
    this.mStretchDrawing = stretch;
    this.mCenterInCanvas = centerInCanvas;
    this.mCanvasHeight = canvasHeight;
    this.mCanvasWidth = canvasWidth;
    if (forme) {
      this.mCalculatedCodeF = forme.CodeForme;
      this.mInterfaceForme = forme;
      this.calculerPath2D(forme);
    } else {
      console.log('forme non valide: ', forme);
    }
  }

    /**
     * Code repris et adapter d'armaor pour le scaling des X
     * @param canvas ?
     * @param stretch ?
     */
    private static calculRatioShape(canvas: HTMLCanvasElement, stretch: boolean): Point2D {
        let scaleX = canvas.width / CUtilForme.CST_LARGEURCOTATION_DANS_ARMAOR;
        scaleX = (canvas.width - (CUtilForme.CST_DECALAGE_X_DESSIN_ARMAOR * scaleX)) / CUtilForme.CST_LARGEURDESSIN_DANS_ARMAOR;
        //FormeCanvas.m_RatioCotationX := (Rect.Width-DeplacePixels) / LARGEURCOTATION;
        //FormeCanvas.m_RatioDessinX := (Rect.Width-DeplacePixels-(70*FormeCanvas.m_RatioCotationX)) / LARGEURDESSIN;
        const scaleY = canvas.height / CUtilForme.CST_HAUTEURDESSIN_DANS_ARMAOR;
        const ratioXY = Math.min(scaleX, scaleY);     // Pour recupere une image non étirer dans le canvas, on prend le même ration pour le X & Y, le ration minimume pour pas dépaser du canvas
        let result: Point2D = new Point2D(ratioXY, ratioXY);
        if (stretch) {
          result.X = scaleX;
          result.Y = scaleY;
        }
        return result;
    }

    private static getScaleCotation(canvas: HTMLCanvasElement, stretch: boolean): Point2D {
        //let scaleX = canvas.width / CUtilForme.CST_LARGEURCOTATION_DANS_ARMAOR;
        //let scaleY = canvas.height / CUtilForme.CST_HAUTEURCOTATION_DANS_ARMAOR;
        //let left = (+cote.Region_Left * scaleX);// - (UtilForme.LARGEURPETITCADRE_DANS_ARMAOR / 2);
        //let top = (+cote.Region_Top * scaleY);// - (UtilForme.HAUTEURPETITCADRE / 2);

        const scaleX = canvas.width / CUtilForme.CST_LARGEURCOTATION_DANS_ARMAOR;
        const scaleY = canvas.height / CUtilForme.CST_HAUTEURCOTATION_DANS_ARMAOR;
        const minScale = Math.min(scaleX, scaleY);
        const result = new Point2D(minScale, minScale);

        if (stretch) {
          result.X = scaleX;
          result.Y = scaleY;
        }
        return result;
    }

    private calcDisplacement(scaling: number, typeElemToCenter: 'NONE'|'DESSIN'|'COTATION'|'PETITCADRE') {

    }

    /**
     * Retourne la valeur du point X avec le scale donnée sur les X
     * + Code chelou
     * @param ptX ?
     * @param scale ?
     */
    private getScaleX(
        ptX: number,
        scale: number,
        typeElemToCenter: 'NONE'|'DESSIN'|'COTATION'|'PETITCADRE'
    ): number {
        const scalledPoint = (this.mStretchDrawing ? this.mDecalageX : 0) + ((ptX /*- CUtilForme.CST_DECALAGE_X_DESSIN_ARMAOR*/) * scale);
        let displacement = 0;
        if (this.mCenterInCanvas) {
            switch (typeElemToCenter) {
                case 'DESSIN':
                    displacement = ((this.mCanvasWidth / 2 ) - (( CUtilForme.CST_LARGEURDESSIN_DANS_ARMAOR / 2 ) * scale));
                    break;
                case 'COTATION':
                    displacement = ((this.mCanvasWidth / 2 ) - (( CUtilForme.CST_LARGEURCOTATION_DANS_ARMAOR / 2 ) * scale));
                    break;
                case 'PETITCADRE':
                    //displacement = ((this.mCanvasWidth / 2 ) - (( CUtilForme.CST_LARGEURPETITCADRE_DANS_ANGULAR / 2 ) * scale));
                    break;
                case 'NONE': break;
                default:
                    console.warn('Center in cavans not suported with type "' + typeElemToCenter + '"');
                    break;
            }
        }
        return scalledPoint + displacement;
    }

    /**
     * Retourne la valeur du point Y avec le scale donnée sur les Y
     * @param ptY ?
     * @param scale ?
     */
    private getScaleY(
        ptY: number,
        scale: number,
        typeElemToCenter: 'NONE'|'DESSIN'|'COTATION'|'PETITCADRE'
    ): number {
        const value = ((ptY) * scale);
        let displacement = 0;
        if (this.mCenterInCanvas) {
            switch (typeElemToCenter) {
                case 'DESSIN':
                    displacement = ((this.mCanvasHeight / 2 ) - (( CUtilForme.CST_HAUTEURDESSIN_DANS_ARMAOR / 2 ) * scale));
                    break;
                case 'COTATION':
                    displacement = ((this.mCanvasHeight / 2 ) - (( CUtilForme.CST_HAUTEURCOTATION_DANS_ARMAOR / 2 ) * scale));
                    break;
                case 'PETITCADRE':
                    //displacement = ((this.mCanvasHeight / 2 ) - (( CUtilForme.CST_HAUTEURPETITCADRE_DANS_ARMAOR / 2 ) * scale));
                    break;
                case 'NONE': break;
                default:
                    console.warn('Center in cavans not suported with type "' + typeElemToCenter + '"');
                    break;
            }
        }
        return value + displacement;
    }

    /**
     *
     */
    public getScaleXY(
        X: number,
        Y: number,
        scaleX: number,
        scaleY: number,
        typeElemToCenter: 'NONE'|'DESSIN'|'COTATION'|'PETITCADRE'
    ): Point2D {
        return new Point2D(this.getScaleX(X, scaleX, typeElemToCenter),
                           this.getScaleY(Y, scaleY, typeElemToCenter));
    }

    /**
     * Gere le dessin de la forme...
     * Hauteur et largeur du dessin
     * @param forme ?
     */
    private calculerPath2D(forme: Formes) {
        this.mPathShapeDesc = [];
        this.mComments = [];
        this.mCommentPos = [];
        if (forme && forme.Trace) {
            for (let i = 0 ; i < forme.Trace.length ; i++) {
                const pt1X = this.getScaleX(forme.Trace[i].Pt1_X, this.mScaleShapeX, 'DESSIN');
                const pt1Y = this.getScaleY(forme.Trace[i].Pt1_Y, this.mScaleShapeY, 'DESSIN');
                const pt2X = this.getScaleX(forme.Trace[i].Pt2_X, this.mScaleShapeX, 'DESSIN');
                const pt2Y = this.getScaleY(forme.Trace[i].Pt2_Y, this.mScaleShapeY, 'DESSIN');
                const pt3X = this.getScaleX(forme.Trace[i].Pt3_X, this.mScaleShapeX, 'DESSIN');
                const pt3Y = this.getScaleY(forme.Trace[i].Pt3_Y, this.mScaleShapeY, 'DESSIN');
                const comment = forme.Trace[i].Comment;
                const path = new Path2D();
                switch (+forme.Trace[i].TypeTrace) {
                    // TEST OK
                    case ITypeTrace.ttLIGNE:
                    case ITypeTrace.ttLIGNECONTINUE:
                        path.moveTo(pt1X, pt1Y);
                        path.lineTo(pt2X, pt2Y);
                        break;
                    case ITypeTrace.ttRETOURBASGAUCHE:
                    case ITypeTrace.ttRETOURHAUTGAUCHE:
                        this.drawCircle(pt1X, pt1Y, pt2X, pt2Y, 3, path);
                        break;
                    case ITypeTrace.ttRETOURBASDROIT:
                    case ITypeTrace.ttRETOURHAUTDROIT:
                        this.drawCircle(pt1X, pt1Y, pt2X, pt2Y, 4, path);
                        break;
                    case ITypeTrace.ttEPINGLEBASGAUCHE:
                    case ITypeTrace.ttEPINGLEBASDROIT:
                    case ITypeTrace.ttCOURBEBAS:
                        this.drawCircle(pt1X, pt1Y, pt2X, pt2Y, 2, path);
                        break;
                    case ITypeTrace.ttEPINGLEHAUTGAUCHE:
                    case ITypeTrace.ttEPINGLEHAUTDROIT:
                    case ITypeTrace.ttCOURBEHAUT:
                        this.drawCircle(pt1X, pt1Y, pt2X, pt2Y, 1, path);
                        break;
                    case ITypeTrace.ttCERCLE:
                        this.drawCircle(pt1X, pt1Y, pt2X, pt2Y, 0, path);
                        break;
                    // A TESTER
                    case ITypeTrace.ttARCCERCLE:
                    case ITypeTrace.ttRETOUROBLIQUE:
                        this.drawComplex(pt1X, pt1Y, pt2X, pt2Y, pt3X, pt3Y, path);
                        break;
                    case ITypeTrace.ttCOURBEGAUCHE:
                        this.drawCircle(pt1X, pt1Y, pt2X, pt2Y, 3, path);
                        break;
                    case ITypeTrace.ttCOURBEDROITE:
                        this.drawCircle(pt1X, pt1Y, pt2X, pt2Y, 4, path);
                        break;
                    case ITypeTrace.ttCOMMENTAIRE:
                    {
                        this.mComments.push(comment);
                        const pos: Point2D = new Point2D(pt1X, pt1Y);
                        this.mCommentPos.push(pos);
                        break;
                    }
                    // PAS ENCORE FAIT
                    case ITypeTrace.ttUNDEF:
                    case ITypeTrace.ttDELETETRACE:
                    default:
                        console.warn('Trace non gerer', forme.Trace[i]);
                        break;
                }
                this.mPathShapeDesc.push(path);
            }
        }
    }

    public getPathCotation(cote: CoteForme, showRectCotation: boolean): Path2D {
        let path = new Path2D();
        const p1 = this.getScaleXY(cote.Region_Left, cote.Region_Top, this.mScaleCotation.X, this.mScaleCotation.Y, 'COTATION');
        const p2 = this.getScaleXY(cote.Region_Right, cote.Region_Bottom, this.mScaleCotation.X, this.mScaleCotation.Y, 'COTATION');
        const p3 = this.getScaleXY(cote.PC3_X, cote.PC3_Y, this.mScaleCotation.X, this.mScaleCotation.Y, 'COTATION');
        const petitCadreScaled = this.getScaleXY(CUtilForme.CST_LARGEURPETITCADRE_DANS_ARMAOR, CUtilForme.CST_HAUTEURPETITCADRE_DANS_ARMAOR, this.mScaleCotation.X, this.mScaleCotation.Y, 'NONE');

        const regionLeft = p1.X;
        const regionTop = p1.Y;
        const regionRight = p2.X;
        const regionBot = p2.Y;
        const P3X = p3.X;
        const P3Y = p3.Y;
        const ecartCote = this.getScaleXY( 10, 10, this.mScaleShapeX, this.mScaleShapeY, 'NONE');

        switch (+cote.TypeCote) {
            case CST_TYPE_COTE.tcPETITCADRE:
            case CST_TYPE_COTE.tcDIAMETRE:
            case CST_TYPE_COTE.tcNOMBRE:
            case CST_TYPE_COTE.tcANGLE:
            case CST_TYPE_COTE.tcLONGUEUR:
            case CST_TYPE_COTE.tcCOTE:
            case CST_TYPE_COTE.tcSPIRE:
            case CST_TYPE_COTE.tcRAYON:
            case CST_TYPE_COTE.tcDOUBLE:
            case CST_TYPE_COTE.tcSPACER:
            case CST_TYPE_COTE.tcRING:
                if (showRectCotation)
                    path.rect(p1.X, p1.Y, petitCadreScaled.X, petitCadreScaled.Y);          // dessin du petit cadre
                break;
            case CST_TYPE_COTE.tcCOTEVERTICALE:
                path.moveTo(regionLeft - ecartCote.X, regionTop);
                path.lineTo(regionRight + ecartCote.X, regionTop);
                if (cote.Region_Bottom != -1) {
                    path.moveTo(regionLeft - ecartCote.Y, regionBot);
                    path.lineTo(regionRight + ecartCote.Y, regionBot);
                }
                if (cote.PC3_X != -1) {
                    const left: number = P3X - (petitCadreScaled.X / 2);
                    const top: number = P3Y - (petitCadreScaled.Y / 2);
                    const right: number = P3X + (petitCadreScaled.X / 2);
                    const bot: number = P3Y + (petitCadreScaled.Y / 2);
                    path.moveTo(P3X, regionTop);
                    path.lineTo(P3X, top);
                    path.moveTo(P3X, bot);
                    path.lineTo(P3X, regionBot);
                    if (showRectCotation) {
                        path.rect(left, top, right - left, bot - top);
                    }
                }
                break;
            case CST_TYPE_COTE.tcCOTEHORIZONTALE:
                path.moveTo(regionLeft, regionTop - ecartCote.X);
                path.lineTo(regionLeft, regionBot + ecartCote.X);
                if (regionRight != -1) {
                    path.moveTo(regionRight, regionTop - ecartCote.Y);
                    path.lineTo(regionRight, regionBot + ecartCote.Y);
                }
                if (p3.X != -1) {
                    const left: number = P3X - (petitCadreScaled.X / 2);
                    const top: number = P3Y - (petitCadreScaled.Y / 2);
                    const right: number = P3X + (petitCadreScaled.X / 2);
                    const bot: number = P3Y + (petitCadreScaled.Y / 2);
                    path.moveTo(regionLeft, p3.Y);
                    path.lineTo(left, p3.Y);
                    path.moveTo(right, p3.Y);
                    path.lineTo(regionRight, p3.Y);
                    if (showRectCotation) {
                        path.rect(left, top, right - left, bot - top);
                    }
                }
                break;
            case CST_TYPE_COTE.tcPETITCADREANGLE:
                if (showRectCotation) {
                    path.rect(p1.X, p1.Y, petitCadreScaled.X, petitCadreScaled.Y); // Cadre
                }
                //pathTemp.moveTo(regionRight+8, regionTop);
                //pathTemp.ellipse(regionRight+5, regionTop, 3, 3, 0, 0, 2*Math.PI);
                const valueScaled = this.getScaleXY(3, 3, this.mScaleCotation.X, this.mScaleCotation.Y, 'NONE');
                //console.log('valueScaled', valueScaled);
                path.moveTo(regionRight + valueScaled.X, regionTop);
                path.ellipse(regionRight, regionTop, valueScaled.X, valueScaled.Y, 0, 0, 2 * Math.PI);
                break;
            case CST_TYPE_COTE.tcCOTEOBLIQUE:
                path = this.getCoteOblique(regionLeft, regionTop, regionRight, regionBot, P3X, P3Y, showRectCotation, petitCadreScaled);
                break;
            default:
            case CST_TYPE_COTE.tcUNDEF:
            case CST_TYPE_COTE.tcN_EXISTE_PLUS:
            case CST_TYPE_COTE.tcN_EXISTE_PLUS_2:
                console.warn('TypeCote non gerer: ' + cote.TypeCote);
                break;
        }
        return path;
    }

    /**
     * Code repris d'armaor
     */
    private getCoteOblique(regionLeft: number,
                           regionTop: number,
                           regionRight: number,
                           regionBot: number,
                           P3X: number,
                           P3Y: number,
                           showRectCotation: boolean,
                           petitCadreScaled: Point2D): Path2D {
        const path = new Path2D();
        const regionWidth = regionRight - regionLeft;
        const regionHeight = regionBot - regionTop;

        //V1 : notre oblique
        const V1: Point3D = new Point3D(regionRight - regionLeft, regionBot - regionTop, 0);
        //V2 : vecteur Z
        const V2: Point3D = new Point3D(0, 0, 1);
        //V3 : vecteur perpendiculaire
        let V3: Point3D = V1.produitVectoriel(V2);
        V3 = V3.normalize();
        V3 = V3.multiply(CUtilForme.CST_LARGEURPETITCADRE_DANS_ARMAOR / 2); //longueur 6 pxl, cf la fonction ReduitCote pour les horiz et verti
        //On le déplace aux bouts de V1 et on traces les délimiteurs
        path.moveTo(regionLeft, regionTop);
        path.lineTo(Math.round(regionLeft + V3.X), Math.round(regionTop + V3.Y));
        V3 = V3.multiply(-1);
        path.moveTo(regionLeft, regionTop);
        path.lineTo(Math.round(regionLeft + V3.X), Math.round(regionTop + V3.Y));
        V3 = V3.multiply(-1);
        path.moveTo(regionRight, regionBot);
        path.lineTo(Math.round(regionRight + V3.X), Math.round(regionBot + V3.Y));
        V3 = V3.multiply(-1);
        path.moveTo(regionRight, regionBot);
        path.lineTo(Math.round(regionRight + V3.X), Math.round(regionBot + V3.Y));
        //oblique

        let iNorme = 0;     // ?
        const dAng = Math.abs(CUtilit.radToDegree(Math.atan(regionHeight / regionWidth)));          //angle formé par l'oblique
        let V4 = V1.multiply(0.5);                                        //V4 : vecteur du P1 vers le centre
        if (dAng > 25)
            iNorme = V4.norme() - (13 - ((dAng - 25) / 65) * 7);                 //on enleve 13pxl qui représentent la diag ds le rectangle de cote proratisé par l'angle et la diag du rectangle; à 90° on enleve que 6pxl (la hauteur), à 25° on enleve la diag = 13pxl, en dessous on enleve la largeur = 12pxl
        else
            iNorme = V4.norme() - 12;
        V4 = V4.normalize().multiply(iNorme);
        path.moveTo(regionLeft, regionTop);
        path.lineTo(Math.round(regionLeft + V4.X), Math.round(regionTop + V4.Y));
        path.moveTo(regionRight, regionBot);
        path.lineTo(Math.round(regionRight - V4.X), Math.round(regionBot - V4.Y));
        //Rect de la cote
        if (P3X != -1) {
            const specialLeft: number = P3X - (petitCadreScaled.X / 2);
            const specialTop: number = P3Y - (petitCadreScaled.Y / 2);
            const specialRight: number = P3X + (petitCadreScaled.X / 2);
            const specialBot: number = P3Y + (petitCadreScaled.Y / 2);
            if (showRectCotation) {
                path.rect(specialLeft, specialTop, specialRight - specialLeft, specialBot - specialTop);
            }

            //Cadre de la cote
            //if bDrawCadre
            //DessineCadre(RegionSpeciale, PenMode, Couleur);
            //cote (A, B, C... ou valeur numérique)
            //if (LCote <> 0)
            //AfficheCote(sVal, RegionSpeciale, PenMode, Canvas.Font, not bDrawCadre, True);
        }
        return path;
    }

    private drawCircle(scaledPt1X: number, scaledPt1Y: number, scaledPt2X: number, scaledPt2Y: number, circleType: number, path: Path2D) {
        const X1 = scaledPt1X;
        const Y1 = scaledPt1Y;
        const X2 = scaledPt2X;
        const Y2 = scaledPt2Y;
        const width = X2 - X1;
        const height = Y2 - Y1;
        const midX = (X1 + width / 2);
        const midY = (Y1 + height / 2);
        const radX = X2 - X1;
        const radY = Y2 - Y1;

        let start = 0;
        let end = 0;
        let antiClockWise = false;

        switch (circleType) {
            case 0:
                start = 0;
                end = 2 * Math.PI;
                break;
            case 1:
                start = 0;
                end = 1 * Math.PI;
                antiClockWise = true;
                break;
            case 2:
                start = 0;
                end = 1 * Math.PI;
                antiClockWise = false;
                break;
            case 3:
                start = 0.5 * Math.PI;
                end = 1.5 * Math.PI;
                antiClockWise = false;
                break;
            case 4:
                start = 0.5 * Math.PI;
                end = 1.5 * Math.PI;
                antiClockWise = true;
                break;
        }
        // Attention le width et le height ne sont pas identique
        // Les demi cercle haut & bas ne sont pas parfait
        path.ellipse(
            midX,
            midY,
            radX / 2,
            radY / 2,
            0,
            start,
            end,
            antiClockWise
        );
    }

    private drawComplex(scaledPt1X: number, scaledPt1Y: number, scaledPt2X: number, scaledPt2Y: number, scaledPt3X: number, scaledPt3Y: number, path: Path2D) {
        const X1 = scaledPt1X; // Debut
        const Y1 = scaledPt1Y;
        const X2 = scaledPt2X; // Fin
        const Y2 = scaledPt2Y;
        const X3 = scaledPt3X; // Intermediaire
        const Y3 = scaledPt3Y;
        const width = X2 - X1;
        const height = Y2 - Y1;
        let midX = (X1 + width / 2);
        let midY = (Y1 + height / 2);
        const radX = X2 - X1;
        const radY = Y2 - Y1;

        const a: Point2D = new Point2D(X1, Y1);
        const b: Point2D = new Point2D(X2, Y2);
        const c: Point2D = new Point2D(X3, Y3);

        const center = this.calculerCentreCircumCenter(a, b, c);

        // Recupération des données du circumCenter
        const circumCenterX = center.X;
        const circumCenterY = center.Y;

        // Calcul du radius
        const dcx = a.X - circumCenterX;
        const dcy = a.Y - circumCenterY;
        const radiusCircumCenter = Math.sqrt((dcx * dcx) + (dcy * dcy));

        // Recuperation des donnée du rectangle de travail
        const left = (circumCenterX - radiusCircumCenter);
        const top = (circumCenterY - radiusCircumCenter);
        const right = (circumCenterX + radiusCircumCenter);
        const bot = (circumCenterY + radiusCircumCenter);

        // Créatuib du rectangle de travail
        //RectF oval = new RectF();
        //oval.set(left, top, right, bot);

        // Calcul des angle en degrée
        let degreA = Math.round((180 / Math.PI * Math.atan2(a.Y - circumCenterY, a.X - circumCenterX)));
        let degreB = Math.round((180 / Math.PI * Math.atan2(b.Y - circumCenterY, b.X - circumCenterX)));
        let degreC = Math.round((180 / Math.PI * Math.atan2(c.Y - circumCenterY, c.X - circumCenterX)));

        // Transformation en valeur positif
        if (degreA < 0) degreA = 360 + degreA;
        if (degreB < 0) degreB = 360 + degreB;
        if (degreC < 0) degreC = 360 + degreC;

        let start; // Angle de début
        let deplacement = 0; // Longeur de l'angle de deplacement
        let reverse = false; // determination du déplacement de l'angle
        start = degreA;      // Atribution de l'angle de début
        let isC = false;     // Verification de passage par C
        // Balayage clockwise pour essayer de recupere le point B
        for (let i = start; i <= start + 360; i++) {
            let t = i;
            if (t >= 360) t = t - 360;
            if (t == degreB) {
                if (!isC) {
                    reverse = true;
                }
                break;
            }
            if (t == degreC) {
                isC = true;
            }
            deplacement++;
        }

        if (reverse) {
            deplacement = 0;
            // Balayage reverse clockwise pour essayer de recupere le point B
            for (let i = start; i >= (start - 360); i--) {
                let t = i;
                if (t < 0) t = 360 + t;
                if (t == degreB) {
                    break;
                }
                deplacement--;
            }
        }

        midX = (X1 + X2 + X3) / 3;
        midY = (Y1 + Y2 + Y3) / 3;

        path.ellipse(
            ((left + right) / 2),
            ((bot + top) / 2),
            radiusCircumCenter,
            radiusCircumCenter,
            0,
            start * (Math.PI / 180),
            ((start + deplacement) * (Math.PI / 180)),
            reverse
        );

        //console.log('-- COMPLEX --');
        //console.log('Start  : ' + start);
        //console.log('dpl    : ' + deplacement);
        //console.log('reverse: ' + reverse);
        //console.log('-------------');
    }

    private calculerCentreCircumCenter(a: Point2D, b: Point2D, c: Point2D): Point2D {
        /*
         * Circumcenter: The three perpendicular
         * bisectors of the sides of a triangle
         * meet in one point called the circumcenter.
         * It is the center of the circumcircle,
         * the circle circumscribed about the triangle.
         * The area of the triangle is abc/4R=2R^2sinAsinBsinC,
         * where R is the radius of the circumcircle, and ^2 means squared.
         * The distance between the incenter and the circumcenter is sqr(R(R-2r)).
         * If the triangle is obtuse, then the circumcenter is outside the triangle.
         * If it is a right triangle, then the circumcenter is the midpoint of the hypotenuse.
         */

        let circumCenterX;
        let circumCenterY;

        const ax = a.X;
        const ay = a.Y;
        const bx = b.X;
        const by = b.Y;
        const cx = c.X;
        const cy = c.Y;

        // Calcul des millieux
        const midABx = (ax + bx) / 2;
        const midABy = (ay + by) / 2;
        const midBCx = (bx + cx) / 2;
        const midBCy = (by + cy) / 2;

        // Calcul des delta
        const yDelta_a = by - ay;
        const xDelta_a = bx - ax;
        const yDelta_b = cy - by;
        const xDelta_b = cx - bx;

        // Calcul de l'angle
        const aSlope = yDelta_a / xDelta_a;
        const bSlope = yDelta_b / xDelta_b;

        if (yDelta_a == 0) { //aSlope == 0
            circumCenterX = midABx;
            if (xDelta_b == 0) { //bSlope == INFINITY
                circumCenterY = midBCy;
            } else {
                circumCenterY = midBCy + (midBCx - circumCenterX) / bSlope;
            }
        } else if (yDelta_b == 0) { //bSlope == 0
            circumCenterX = midBCx;
            if (xDelta_a == 0) { //aSlope == INFINITY
                circumCenterY = midABy;
            } else {
                circumCenterY = midABy + (midABx - circumCenterX) / aSlope;
            }
        } else if (xDelta_a == 0) {//aSlope == INFINITY
            circumCenterY = midABy;
            circumCenterX = bSlope * (midBCy - circumCenterY) + midBCx;
        } else if (xDelta_b == 0) { //bSlope == INFINITY
            circumCenterY = midBCy;
            circumCenterX = aSlope * (midABy - circumCenterY) + midABx;
        } else {
            circumCenterX = (aSlope * bSlope * (midABy - midBCy) - aSlope * midBCx + bSlope * midABx) / (bSlope - aSlope);
            circumCenterY = midABy - (circumCenterX - midABx) / aSlope;
        }

        return new Point2D(circumCenterX, circumCenterY);
    }
}

/**
 * Calcul dédier au dessin de la forme 99 sur un canvas
 */
export class CShape99 {

    public static CST_POSITION = { POS_CENTER: 'CENTER', POS_BEGIN: 'BEGIN', POS_END: 'END' };

    private mCanvas: HTMLCanvasElement;
    private mShape99: Shape99InfoLine[];
    private mPositionShape: string;     // CST_POSITION
    private mPositionMeasure: string;   //

    /**
     * @param canvas Ou on dessine la forme
     * @param shape99 Information a dessiner (angle , rayon, longueur)
     */
    constructor(canvas: HTMLCanvasElement, shape99: Shape99InfoLine[], autoDraw: boolean = true) {
        this.mCanvas = canvas;
        this.mShape99 = shape99;
        this.mPositionShape = CShape99.CST_POSITION.POS_BEGIN;
        this.mPositionMeasure = CShape99.CST_POSITION.POS_END;
        if (autoDraw)
            this.drawInCanvas();
    }

    /**
     * Aditione sur le mShape99 tout les angle de zero à l'index passé en param
     * @param indexmShape99 Index max a trouvé dans mShape99
     */
    private calcShape99SumAngle(indexmShape99: number): number {
        let result = 0;
        while (indexmShape99 >= 0) {
            result += +this.mShape99[indexmShape99].Angle;
            indexmShape99--;
        }
        return result;
    }

    /**
     * Calcule le point (X,Y) de déstination en fonction du point d'origine de la longueur du trait & de l'angle donnés
     * @param xOrigin   Emplacement X origine
     * @param yOrigin   Emplacement Y origine
     * @param angle     Angle du tracé, ! Angle par rapport au point d'origine, 0=haut !
     * @param long      Longueure du tracé
     */
    private CalcPointDest(xOrigin: number, yOrigin: number, angle: number, long: number ): Point2D {
        return new Point2D((xOrigin + long * Math.cos(angle)),
                           (yOrigin + long * Math.sin(angle)));
    }

    public drawInCanvas(drawShape: boolean = true, drawCotation: boolean = true) {
        CUtilForme.clearCanvas(this.mCanvas);
        if (drawShape)      this.drawShape();
        if (drawCotation)   this.drawCotation();
    }

    private drawShape() {
      // 0.9 = 90% de la surface utilisable pour afficher la forme
      // Evite que les trait se retrouve colé au bord du canavas
      const scaleMargin = 0.9;

      const listPointXY: Point2D[] = [];
      // Calcule des infos de la forme 99 en une liste de points X & Y
      for (let i = 0 ; i < this.mShape99.length - 1 ; i++) {
        const originX = listPointXY[i].X;
        const originY = listPointXY[i].Y;
        listPointXY.push(this.CalcPointDest(
          originX, originY,
          CUtilit.toRadian(this.calcShape99SumAngle(i)),
          +this.mShape99[i + 1].Length
        ));
      }

      // Partie redimentionnement des points
      //////////////////////////////////////

      // On cherche a connaitre le minimum et le maximum sur les deux axe afin d'avoir un rectangle qui contiens la forme
      const min: Point2D = new Point2D(0, 0);
      const max: Point2D = new Point2D(0, 0);
      let rectWidth = 0;
      let rectHeight = 0;
      for (let i =  0 ; i < listPointXY.length ; i++) {
        if (listPointXY[i].X > max.X)
          max.X = listPointXY[i].X;
        if (listPointXY[i].Y > max.Y)
          max.Y = listPointXY[i].Y;
        if (listPointXY[i].X < min.X)
          min.X = listPointXY[i].X;
        if (listPointXY[i].Y < min.Y)
          min.Y = listPointXY[i].Y;
      }
      rectWidth = max.X - min.X;
      rectHeight = max.Y - min.Y;

      // Ici on doit determiner la taille du trait que l'on va utiliser car ce sera utiliser par la suite pour redimensionner le canvas
      // 5000 valeur arbitraire pour donner une epaiseur au trait
      const lineScale = (
        g_params.measureUnitStr == 'cm' ?
          Math.max(this.mCanvas.height, this.mCanvas.width) :
          Math.max(this.mCanvas.height, this.mCanvas.width) * 10
      ); // Enfonction cm ou mm le ratio pour connaitre l'épaiseur du trait sera different

      let lineWidth = lineScale / Math.max(rectHeight, rectWidth);      // On divise en fontion de la plus grande longueure   du dessin

      lineWidth = Math.max(3, lineWidth); // On garde 1px de minimum pour l'épaiseur du trait

      // On calcule le ratio pour etre dans le cadre avec la plus grande longueur du rectangle qui compose la forme99
      const minCavnas = Math.min(this.mCanvas.height, this.mCanvas.width);
      const maxDrawing = Math.max(rectHeight, rectWidth);
      let scaleValue = (minCavnas - (lineWidth)) / maxDrawing;  // On prend en compte l'épaisseur du trait dans ontre calcul

      // Pour eviter que la forme touche les bord de l'image
      scaleValue *= scaleMargin;

      // Ici on a le décalage a utiliser pour centrer la piece sur le zero du canvans
      // On décale en fonction de la valeur minimum sur les deux axes et en inversant le signe (-) => (+)
      // On multiplie par le ration (scalevalue) pour ne pas dépasser la taille donnée

      let tempX = ( (min.X * -1) * scaleValue ) + ( lineWidth / 2 );
      let tempY = ( (min.Y * -1) * scaleValue ) + ( lineWidth / 2 );

      // Maintenant on applique un autre décalage pour centrer la forme dans le milieu du canvas
      // Le décalage X est gerer en fonction d'un parametre de position début, centre, fin
      switch (this.mPositionShape) {
        case CShape99.CST_POSITION.POS_CENTER:
          tempX = tempX + ( (this.mCanvas.width / 2) - ((rectWidth * scaleValue) / 2) - (lineWidth / 2) );
          break;
        case CShape99.CST_POSITION.POS_END:
          throw 'TODO: Position end non gerer';
        case CShape99.CST_POSITION.POS_BEGIN:
        default:
          // Pas de modif sur les X donc tempX = tempX :)
          // Mais on ajoute un padding pour eviter l'effet écraser sur la fenetre
          tempX = tempX + Math.min(5, ( (this.mCanvas.width / 2) - ((rectWidth * scaleValue) / 2) - (lineWidth / 2) ));
          break;
      }
      tempY = tempY + ( (this.mCanvas.height / 2) - ((rectHeight * scaleValue) / 2) - (lineWidth / 2) );

      const decalageXY: Point2D =  new Point2D(tempX, tempY);

      // Redimentionement des points en fonction du ratio (scaleValue)
      for (let i = 0 ; i < listPointXY.length ; i++) {
        listPointXY[i].X = (listPointXY[i].X * scaleValue);
        listPointXY[i].Y = (listPointXY[i].Y * scaleValue);
      }

      const mPath2DDrawing: Path2D = new Path2D();
      // Placement des point dans un obj path2D
      for (let i = 0 ; i < listPointXY.length ; i++) {
        const X = listPointXY[i].X + decalageXY.X;
        const Y = listPointXY[i].Y + decalageXY.Y;
        if (i == 0) mPath2DDrawing.moveTo(X, Y);
        else        mPath2DDrawing.lineTo(X, Y);
      }

      // Dessin des points
      const ctx = this.mCanvas.getContext('2d');
      if (ctx == null)
        return;

      const oldStrockStyle = ctx.strokeStyle;
      const oldShadowOffsetX = ctx.shadowOffsetX;
      const oldShadowOffsetY = ctx.shadowOffsetY;
      const oldShadowColor = ctx.shadowColor;
      const oldShadowBlur = ctx.shadowBlur;
      ctx.shadowOffsetX = 2;
      ctx.shadowOffsetY = 2;
      ctx.shadowColor = '#696969';
      ctx.shadowBlur = 5;

      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = '#4a79d9';            // Bleu d'armaor
      ctx.stroke(mPath2DDrawing);
      ctx.strokeStyle = 'black';              //

      ctx.strokeStyle = oldStrockStyle;
      ctx.shadowOffsetX = oldShadowOffsetX;
      ctx.shadowOffsetY = oldShadowOffsetY;
      ctx.shadowColor = oldShadowColor;
      ctx.shadowBlur = oldShadowBlur;
    }

    /**
     * dessins de la cote sur la droite du canvas
     */
    private drawCotation() {
        // Au maximume 11px ou le quart du canvans pour écrire tout les text
        const paddingPXMeasure = 5;
        const minTextSizePx = 11;
        const textHeightPX = Math.max(
            minTextSizePx,
            this.mCanvas.height / (4 * this.mShape99.length - 1)
        ); // Taille de la fonte en px

        // Parametrage du canvas
        const ctx = this.mCanvas.getContext('2d');
        if (ctx == null)
          return;
        ctx.lineWidth = 1;
        ctx.font = textHeightPX + 'px sans-serif';
        ctx.fillStyle = 'black';               // Dessin des cote en noir

        // Ici on prepare les text à afficher
        const textToShow: string[] = [];
        let maxWidth = 0;
        for (let i = 1 ; i < this.mShape99.length ; i++) {
            const text = (this.mShape99[i].Length + ' ') + (this.mShape99[i].Angle ? this.mShape99[i].Angle + '°' : '');
            textToShow.push(text);
            // On determine la long max du text
            maxWidth = Math.max(maxWidth, (ctx.measureText(text).width + paddingPXMeasure));
        }

        // Dessin du texte
        for (let i = 1 ; i <= textToShow.length ; i++) {
            const text =
                (this.mShape99[i].Length + ' ') +
                (this.mShape99[i].Angle ? this.mShape99[i].Angle + '°' : '');
            let x = 0;
            switch (this.mPositionMeasure) {
                case CShape99.CST_POSITION.POS_END:
                    x = this.mCanvas.width - maxWidth;
                    break;
                case CShape99.CST_POSITION.POS_CENTER: // Center non gerer
                case CShape99.CST_POSITION.POS_BEGIN:
                default:
                    x = 0;
                    break;

            }
            const y = i * textHeightPX; // On commence a 1 ici donc -1 nessecaire
            ctx.fillText(text, x, y);
        }


    }

    /**
     * CST_POSITION
     */
    set positionShape(position: string) {
        this.mPositionShape = position;
    }

    /**
     * CST_POSITION
     */
    set positionMeasure(position: string) {
        this.mPositionMeasure = position;
    }

}

export class CUtilForme {

    public static CST_LARGEURDESSIN_DANS_ARMAOR = 500;  // Tracé de tout les tracé de la forme dans un rectangle
    public static CST_HAUTEURDESSIN_DANS_ARMAOR = 200;  //
    public static CST_LARGEURCOTATION_DANS_ARMAOR = 320;    // Tracé de toute les cotataions dans un rectangle
    public static CST_HAUTEURCOTATION_DANS_ARMAOR = 100;    //
    public static CST_LARGEURPETITCADRE_DANS_ARMAOR = 24;   // Tracé d'un cadre qui doit contenir une cote
    public static CST_HAUTEURPETITCADRE_DANS_ARMAOR = 13;   //

    public static CST_DECALAGE_X_DESSIN_ARMAOR = 70; // Ufore => procedure CShape.DrawShape2 => FormeCanvas.m_RatioDessinX := (Rect.Width-DeplacePixels-(70*FormeCanvas.m_RatioCotationX)) / LARGEURDESSIN;

    public static CST_LARGEURPETITCADRE_DANS_ANGULAR = 35; // Correspond à 5chara rentrée dans un input avec une taille par defaut (XXpx definir dans le css)

    public static clearCanvas(canvas: HTMLCanvasElement) {
        if (!canvas) return;
        const canvasContext = canvas.getContext('2d');
        if (canvasContext == null)
          return;
        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
    }

    /**
     * @param canvas ?
     * @param forme ?
     */
    public static drawShapeInCanvas(canvas: HTMLCanvasElement, forme: CCalcForme) {
        const ctx = canvas.getContext('2d');
        if (ctx == null)
          return;
        CUtilForme.clearCanvas(canvas);
        const oldLineWidth = ctx.lineWidth; // = 1 defaul value
        const oldStrockStyle = ctx.strokeStyle;
        const oldShadowOffsetX = ctx.shadowOffsetX;
        const oldShadowOffsetY = ctx.shadowOffsetY;
        const oldShadowColor = ctx.shadowColor;
        const oldShadowBlur = ctx.shadowBlur;
        ctx.lineWidth = 3;
        ctx.strokeStyle = '#4a79d9'; // Bleu d'armaor
        ctx.shadowOffsetX = 2;
        ctx.shadowOffsetY = 2;
        ctx.shadowColor = '#696969';
        ctx.shadowBlur = 5;
        forme.mPathShapeDesc.forEach(path => {
            ctx.stroke(path);
        });
        ctx.lineWidth = oldLineWidth;
        ctx.strokeStyle = oldStrockStyle;
        ctx.shadowOffsetX = oldShadowOffsetX;
        ctx.shadowOffsetY = oldShadowOffsetY;
        ctx.shadowColor = oldShadowColor;
        ctx.shadowBlur = oldShadowBlur;
        forme.mComments.forEach((comment, index) => {
            ctx.font = '16px Arial';
            ctx.fillStyle = 'black';
            ctx.fillText(comment, forme.mCommentPos[index].X, forme.mCommentPos[index].Y);
        });
    }

    public static drawAndGetInput( // TODO: a améliorer
        canvas: HTMLCanvasElement,
        forme: CCalcForme,
        showHiddenCotation?: boolean,
        writeLetterInRect?: boolean,
        showRectCotation?: boolean
    ): IInputCotation[] {
        if (showHiddenCotation == undefined) showHiddenCotation = false;
        if (writeLetterInRect == undefined) writeLetterInRect = false;
        if (showRectCotation == undefined) showRectCotation = false;
        function getCoteText(cote: CoteForme): string {
            switch (+cote.TypeCote) {
                case CST_TYPE_COTE.tcDIAMETRE: return 'Dia = ';
                case CST_TYPE_COTE.tcNOMBRE: return 'Qty = ';
                case CST_TYPE_COTE.tcANGLE: return 'Ang = ';
                case CST_TYPE_COTE.tcLONGUEUR: return 'Lg = ';
                case CST_TYPE_COTE.tcCOTE: return 'Cot = ';
                case CST_TYPE_COTE.tcSPIRE: return 'Spi = ';
                case CST_TYPE_COTE.tcRAYON: return 'Ray = ';
                case CST_TYPE_COTE.tcDOUBLE: return 'Double= ';
                case CST_TYPE_COTE.tcSPACER: return 'Spacer= ';
                case CST_TYPE_COTE.tcRING: return 'Ring= ';
            }
            return '';
        }
        const characterUpperCase = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        function getIntoToMatchChar(val: number): string {
            let char = '';
            if (val < characterUpperCase.length) char = characterUpperCase[val];
            else console.error('Text hors limite');
            return char;
        }
        const arrayCotation: IInputCotation[] = [];
        let nbCote = 0;  // Pour atribuer l'id de l'input // Nessecaire car on lit le tableau grace a cet id aussi donc doit commencer par 0
        const ctx = canvas.getContext('2d');
        if (ctx == null)
          return arrayCotation;
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'black'; // on passe la couleur des fill en noir
        const minTextSizePx = 10;   // on définie la font size minimale à 10px
        const textHeightPX = Math.max(minTextSizePx, (0.04 * Math.min(forme.mCanvasHeight, forme.mCanvasWidth)));   // calcule permettant d'adapter la taille de la font en fonction des dimensions du canvas
        ctx.font = textHeightPX + 'px sans-serif';    // attribution de la font size ainsi que du style de la font-
        if (forme.mInterfaceForme) {
            for (let i = 0 ; i < forme.mInterfaceForme.Cote.length ; i++) {
                const cote = forme.mInterfaceForme.Cote[i];
                // Pour l'input
                const inputCotation = CUtilForme.getInputCotation(cote, canvas, forme);
                inputCotation.Id = nbCote;
                nbCote++;
                if (inputCotation.visible || showHiddenCotation) {
                    arrayCotation.push(inputCotation);

                    // Pour dessiner la cote
                    const textInput = getCoteText(cote);
                    //console.log('ctx.strokeText('+text+', '+(inputCotation.Width-widthText)+', '+inputCotation.Y+');');
                    const scaleLetter = forme.getScaleXY(CUtilForme.CST_LARGEURPETITCADRE_DANS_ARMAOR, CUtilForme.CST_HAUTEURPETITCADRE_DANS_ARMAOR, forme.mScaleCotation.X, forme.mScaleCotation.Y, 'NONE');
                    ctx.fillText(textInput, (inputCotation.X - ctx.measureText(textInput).width), inputCotation.Y + (scaleLetter.Y / 2)); // permet de dessiner l'info sur l'input (ex: rad) modfication sur Y a faire
                    if (writeLetterInRect) {
                        const letterCote = getIntoToMatchChar(+cote.LCote);
                        const lenghtLetter = ctx.measureText(letterCote).width;
                        const midInputX = inputCotation.X + ((scaleLetter.X / 2) - lenghtLetter / 2); // inputCotation.X + ((inputCotation.Width / 2) à modifier
                        const midInputY =  inputCotation.Y + (scaleLetter.Y / 2); // inputCotation.Y + (inputCotation.Height / 2) à modifier
                        ctx.fillText(letterCote, midInputX, midInputY); // dessine la lettre de la côte (ex: A)
                    }
                    ctx.stroke(forme.getPathCotation(cote, showRectCotation));
                }
            }
        }
        return arrayCotation;
    }

    public static getInputCotation(cote: CoteForme, canvas: HTMLCanvasElement, forme: CCalcForme): IInputCotation {
        function getScale(x: any, y: any): Point2D { // Sous fonction pour avoir les bonne valeurs lors des calcul de cote
            return new Point2D(x * scaleX, y * scaleY);
        }
        // Proportition X & Y des dessins par rapport a la taille du canvas
        let scaleX = canvas.width / CUtilForme.CST_LARGEURCOTATION_DANS_ARMAOR;
        let scaleY = canvas.height / CUtilForme.CST_HAUTEURCOTATION_DANS_ARMAOR;
        let p1;
        let p2;
        let p3;
        let specialLeft: number;
        let specialTop: number;
        let specialRight: number;
        let specialBot: number;
        if (forme.mCenterInCanvas) {
            const scalePetitCadre = forme.getScaleXY(CUtilForme.CST_LARGEURPETITCADRE_DANS_ANGULAR, CUtilForme.CST_HAUTEURPETITCADRE_DANS_ARMAOR, forme.mScaleCotation.X, forme.mScaleCotation.Y, 'NONE');
            p1 = forme.getScaleXY(cote.Region_Left, cote.Region_Top, forme.mScaleCotation.X, forme.mScaleCotation.Y, 'COTATION');
            p2 = forme.getScaleXY(cote.Region_Right, cote.Region_Bottom, forme.mScaleCotation.X, forme.mScaleCotation.Y, 'COTATION');
            p3 = forme.getScaleXY(cote.PC3_X, cote.PC3_Y, forme.mScaleCotation.X, forme.mScaleCotation.Y, 'COTATION');

            specialLeft = p3.X - (scalePetitCadre.X / 2);
            specialTop = p3.Y - (scalePetitCadre.Y / 2);
            specialRight = p3.X + (scalePetitCadre.X / 2);
            specialBot = p3.Y + (scalePetitCadre.Y / 2);
        } else {
            // On garde un seule des deux ration
            if (!forme.mStretchDrawing) {
                const scaleXY = Math.min(scaleX, scaleY);
                scaleX = scaleXY;
                scaleY = scaleXY;
            }

            // On converti le rectangle recu par ArmaServ en serie de point scale sur la taille du canvas
            p1 = getScale(cote.Region_Left, cote.Region_Top);
            p2 = getScale(cote.Region_Right, cote.Region_Bottom);
            p3 = getScale(cote.PC3_X, cote.PC3_Y);

            // ?? Pour le calcul des cote Oblique ??
            // "CST_LARGEURPETITCADRE_DANS_ARMAOR" Remplacé par "CST_LARGEURPETITCADRE_DANS_ANGULAR"
            specialLeft = p3.X - (CUtilForme.CST_LARGEURPETITCADRE_DANS_ANGULAR / 2);
            specialTop = p3.Y - (CUtilForme.CST_HAUTEURPETITCADRE_DANS_ARMAOR / 2);
            specialRight = p3.X + (CUtilForme.CST_LARGEURPETITCADRE_DANS_ANGULAR / 2);
            specialBot = p3.Y + (CUtilForme.CST_HAUTEURPETITCADRE_DANS_ARMAOR / 2);
        }

        switch (+cote.TypeCote) {
            case CST_TYPE_COTE.tcCOTEVERTICALE:
            case CST_TYPE_COTE.tcCOTEHORIZONTALE:
            case CST_TYPE_COTE.tcCOTEOBLIQUE:
                const decalageX = forme.getScaleXY(8, 8, forme.mScaleShapeX, forme.mScaleShapeY, 'NONE');
                const decalageY = forme.getScaleXY(1, 1, forme.mScaleShapeX, forme.mScaleShapeY, 'NONE');
                return {
                    Id: +cote.LCote,
                    X: specialLeft + decalageX.X,
                    Y: specialTop + decalageY.Y,
                    Width: specialRight - specialLeft,
                    Height: specialBot - specialTop,
                    visible: CUtilForme.CoteFormeVisible(cote),
                    writable: (+cote.Calc == CALC_VISIBILITY_COTE.ALWAS_VISIBLE)
                };
            default:
            case CST_TYPE_COTE.tcUNDEF:
            case CST_TYPE_COTE.tcN_EXISTE_PLUS:
            case CST_TYPE_COTE.tcN_EXISTE_PLUS_2:
            case CST_TYPE_COTE.tcPETITCADREANGLE:
            case CST_TYPE_COTE.tcDIAMETRE:
            case CST_TYPE_COTE.tcNOMBRE:
            case CST_TYPE_COTE.tcANGLE:
            case CST_TYPE_COTE.tcLONGUEUR:
            case CST_TYPE_COTE.tcCOTE:
            case CST_TYPE_COTE.tcSPIRE:
            case CST_TYPE_COTE.tcRAYON:
            case CST_TYPE_COTE.tcDOUBLE:
            case CST_TYPE_COTE.tcSPACER:
            case CST_TYPE_COTE.tcRING:
            case CST_TYPE_COTE.tcPETITCADRE: // Cote simple input déja fait
                return {
                    Id: +cote.LCote,
                    X: p1.X,
                    Y: p1.Y,
                    Width: CUtilForme.CST_LARGEURPETITCADRE_DANS_ANGULAR,
                    Height: CUtilForme.CST_HAUTEURPETITCADRE_DANS_ARMAOR,
                    visible: CUtilForme.CoteFormeVisible(cote),
                    writable: (+cote.Calc == CALC_VISIBILITY_COTE.ALWAS_VISIBLE)
                };
        }
    }

    public static CoteFormeVisible(forme: CoteForme): boolean {
        //console.log('Visiblity : ' + forme.Calc + ' : ' + (+forme.Calc != CALC_VISIBILITY_COTE.HIDDEN_TO_CALCULATE));
        return +forme.Calc != CALC_VISIBILITY_COTE.HIDDEN_TO_CALCULATE;
    }

    public static countVisibleMeasure(forme: Formes): number {
        let result = 0;
        for (let i = 0 ; i < forme.Cote.length ; i++)
            if (this.CoteFormeVisible(forme.Cote[i])) result++;
        return result;
    }

    public static isCalculatedMeasure(forme: Formes, idMeasure: number): boolean {
        if (idMeasure > forme.Cote.length - 1) return false;
        if (forme.Cote[idMeasure] === undefined) return false;
        return +forme.Cote[idMeasure].Calc != CALC_VISIBILITY_COTE.ALWAS_VISIBLE;
    }

    public static async UpdateShapeFavorite(http: HttpClient, shape: Formes, favoriteShape?: FavoriteShape) {
      if (favoriteShape == null) {
        await ArmaServConnection.aPOST(http, 'ShapeFavorite', {Shape: shape, Status: FavoriteShapeStatus.Default, PanelVisible: false});
      } else {
        await ArmaServConnection.aPOST(http, 'ShapeFavorite', {Shape: shape, Status: favoriteShape.Status, PanelVisible: favoriteShape.PanelVisible});
      }
    }
}

export class PhaseProduction {
  public Angle: number;
  public Angle3D: boolean;
  public Longueur: number;
  public RayonCintrage: number; // Arc de cercle

  public static emptyCreate(): PhaseProduction {
    return new PhaseProduction(0, false, 0, 0);
  }

  public constructor(angle: number, angle3d: boolean, longueur: number, rayoncintrage: number) {
    this.Angle = angle;
    this.Angle3D = angle3d;
    this.Longueur = longueur;
    this.RayonCintrage = rayoncintrage;
  }

  public isArc(): boolean {
    return this.RayonCintrage != 0;
  }

  public static getListPhaseProdFromShape99(shape99InfoLigne: Shape99InfoLine[]): PhaseProduction[] {
    const arrayPhaseProd: PhaseProduction[] = [];
    for (let i = 0 ; i < shape99InfoLigne.length - 1 ; i++) {
      const curInfoLigne: Shape99InfoLine = shape99InfoLigne[i];
      const nextLine: Shape99InfoLine = shape99InfoLigne[i + 1];
      const angle: number = +curInfoLigne.Angle;
      const longueur: number = +nextLine.Length;

      arrayPhaseProd.push(new PhaseProduction(
        angle,
        false,
        longueur,
        0
      ));
    }
    return arrayPhaseProd;
  }

  public static getListPhaseProdFromArmaorBVBS(armaorBvbs: string): PhaseProduction[] {
    function safeGetIntFromCote(coteStr: string): number {
      coteStr = coteStr.trim();
      let coteNumber = 0;
      if (coteStr == '' || isNaN(+coteStr))
        coteNumber = 0;
      else
        coteNumber = +coteStr;
      return coteNumber;
    }

    const arrayPhaseProd: PhaseProduction[] = [];
    if (armaorBvbs) {
      armaorBvbs += armaorBvbs + 'A'; // Pour ne pas à avoir à gérer la dernière cote à part
      let cercle = false;
      let angle3d = false;
      let currentPhaseProduction: PhaseProduction | null = null;
      let cote = '';

      for (let i = 0 ; i < cote.length ; i++) {
        const aChar = cote.charAt(i);
        if (!isNaN(+aChar) || aChar == '-' || aChar == '+') {
          cote = cote + aChar;
        } else {
          switch (aChar) {
            case 'A': // Angle
              if (currentPhaseProduction != null) {
                if (!cercle) {
                  currentPhaseProduction.Longueur = safeGetIntFromCote(cote);
                  currentPhaseProduction.RayonCintrage = 0;
                  arrayPhaseProd.push(currentPhaseProduction);
                } else {
                  currentPhaseProduction.RayonCintrage = safeGetIntFromCote(cote);
                  arrayPhaseProd.push(currentPhaseProduction);
                }
                cercle = false;
                angle3d = false;
              }
              break;
            case 'D': // 3D
            case 'E': // 3D ?
              angle3d = true;
              break;
            case 'L': // Longueur
              if (currentPhaseProduction == null && arrayPhaseProd.length > 0)
                cote = '';
              currentPhaseProduction = PhaseProduction.emptyCreate();
              currentPhaseProduction.Angle = safeGetIntFromCote(cote);
              currentPhaseProduction.Angle3D = angle3d;
              break;
            case 'C': // Indique que l'on va faire un arc de cercle
              cercle = true;
              continue; //break;
            case 'R': // Rayon de la cote + fin arc de cercle
              if (currentPhaseProduction != null)
                currentPhaseProduction.Longueur = safeGetIntFromCote(cote);
              break;
            case 'M': // Retraid du mandrin ?
            default:
              break;
          }
          if (aChar != 'M')
            cote = '';
        }
      }
    }
    return arrayPhaseProd;
  }
}

export class DrawPhaseProduction {

    public static draw(arrayPhaseProduction: PhaseProduction[],
                       htmlCanvasElement: HTMLCanvasElement,
                       steelDiameter: number,
                       formerDiameter: number) {
        const drawPhaseProd = new DrawPhaseProduction(steelDiameter, formerDiameter);
        drawPhaseProd.resolveArrayPhaseProd(arrayPhaseProduction);
        const canvasContext = htmlCanvasElement.getContext('2d');
        if (canvasContext == null)
          return;
        drawPhaseProd.drawAndResizeCanvas(canvasContext, htmlCanvasElement.width, htmlCanvasElement.height);
    }

    private readonly mCurrent: Point2D;
    private mCurrentDirection: number; // En haut = 0, 90=est, 180=sud, 270=west, 360=nord
    private readonly mPath: Path2D;
    private readonly mSteelDiameter: number;
    private readonly mFormerDiameter: number;

    private minWidth: number;
    private maxWidth: number;
    private minHeight: number;
    private maxHeight: number;


    private constructor(steelDiameter: number, formerDiameter: number) {
        this.mCurrent = new Point2D(0, 0);
        this.mCurrentDirection = -90; // Pour commencer au nord comme sur armaor
        this.mPath = new Path2D();
        this.mPath.moveTo(this.mCurrent.X, this.mCurrent.Y);
        this.minWidth = 0;
        this.maxWidth = 0;
        this.minHeight = 0;
        this.maxHeight = 0;
        this.mSteelDiameter = steelDiameter;
        this.mFormerDiameter = formerDiameter;
    }

    private addDirection(angle: number) {
        this.mCurrentDirection += angle;
    }


    resolveArrayPhaseProd(arrayPhaseProduction: PhaseProduction[]) {
        for (let i = 0 ; i < arrayPhaseProduction.length ; i++) {
            const curPhaseProd: PhaseProduction = arrayPhaseProduction[i];
            let nextPhase = null;
            let previousPhase = null;
            if (i < arrayPhaseProduction.length - 1)
                nextPhase = arrayPhaseProduction[i + 1];
            if (i > 0)
                previousPhase = arrayPhaseProduction[i - 1];
            if (i == 0)
                this.addDirection(curPhaseProd.Angle);
            this.resolvePhaseProd(curPhaseProd, nextPhase, previousPhase);
        }
    }

    resolvePhaseProd(currentPhase: PhaseProduction,
                     nextPhase: PhaseProduction | null,
                     previousPhase: PhaseProduction | null) {
        let lengthPreviousArcOfCircle = 0;
        let radiusPreviousArc = 0;
        let lenghtToDraw: number = currentPhase.Longueur;
        let lengthNextArcLength = 0;
        let radiusNextArc = 0;

        // Si on à une phase precedente alors on la finis
        if (previousPhase != null) {
            // ! Les info de l'angle sont toujours sur la phas d'apres, donc si on cherche a terminer l'angle de la phase precedente on recuperer l'angle de la phase en cours
            if (Math.abs(currentPhase.Angle) >= 90 && Math.abs(currentPhase.Angle) <= 180) {
                // On recuperer la longueur que l'on perd a cause du plie
                lengthPreviousArcOfCircle = (((currentPhase.Angle * Math.PI * (this.mFormerDiameter + this.mSteelDiameter)) / 360) / 2);
                radiusPreviousArc = (this.mFormerDiameter / 2) + (this.mSteelDiameter / 2);
                lenghtToDraw -= Math.abs(lengthPreviousArcOfCircle);
            } else if (Math.abs(currentPhase.Angle) >= 1 && Math.abs(currentPhase.Angle) <= 89) {
                lengthPreviousArcOfCircle = (((currentPhase.Angle * Math.PI * (this.mFormerDiameter + this.mSteelDiameter)) / 360) / 2);
                radiusPreviousArc = (this.mFormerDiameter / 2) + (this.mSteelDiameter / 2);
                lenghtToDraw -= Math.abs((
                        Math.sin(currentPhase.Angle / 2) *
                                (this.mSteelDiameter + this.mFormerDiameter / 2) /
                                Math.cos(currentPhase.Angle / 2)
                ));
            } else console.error('resolve: Imposible de traiter l\'angle : ' + currentPhase.Angle);
        }

        // Identique si on à une phase suivante
        if (nextPhase != null) {
            if (Math.abs(nextPhase.Angle) >= 90 && Math.abs(nextPhase.Angle) <= 180) {
                // On recupere la longueure que l'on perd a cause du prochain pli de la barre
                lengthNextArcLength = (((nextPhase.Angle * Math.PI * (this.mFormerDiameter + this.mSteelDiameter)) / 360) / 2);
                radiusNextArc = (this.mFormerDiameter / 2) + (this.mSteelDiameter / 2);
                lenghtToDraw -= Math.abs(lengthNextArcLength);
            } else if (Math.abs(nextPhase.Angle) >= 1 && Math.abs(nextPhase.Angle) <= 89) {
                lengthNextArcLength = (((nextPhase.Angle * Math.PI * (this.mFormerDiameter + this.mSteelDiameter)) / 360) / 2);
                radiusNextArc = (this.mFormerDiameter / 2) + (this.mSteelDiameter / 2);
                lenghtToDraw -= Math.abs((
                        Math.sin(nextPhase.Angle / 2) *
                                (this.mSteelDiameter + this.mFormerDiameter / 2) /
                                Math.cos(nextPhase.Angle / 2)
                ));
            } else console.error('resolve: Imposible de traiter l\'angle : ' + nextPhase.Angle);
        }

        // Tracé
        if (previousPhase != null)
            this.drawArc(radiusPreviousArc, lengthPreviousArcOfCircle, 0); // Fin du dessin de l'angle
        if (currentPhase.isArc())
            this.drawArc(currentPhase.RayonCintrage, currentPhase.Longueur, 0);
        else
            this.drawLine(lenghtToDraw, 0); // Dessin de la longueur de la barre
        if (nextPhase != null)
            this.drawArc(radiusNextArc, lengthNextArcLength, 0); // Début du dessin de l'angle
    }

    /**
     * Old way
     * @param currentPhase ?
     */
    resolveSimple(currentPhase: PhaseProduction) {
        if (currentPhase.isArc())
            this.drawArc(currentPhase.RayonCintrage, currentPhase.Longueur, currentPhase.Angle);
        else
            this.drawLine(currentPhase.Longueur, currentPhase.Angle);
    }

    /**
     *
     * @param distance ?
     * @param direction ?
     */
    drawLine(distance: number, direction: number) {
        const point: Point2D = this.getPointFromAnglePath(this.mCurrent.X, this.mCurrent.Y, distance, (this.mCurrentDirection + direction));
        this.lineToAndCalcBox(point.X, point.Y);
        this.mCurrentDirection += direction;
        this.mCurrent.X = point.X;
        this.mCurrent.Y = point.Y;
    }

    /**
     *
     * @param radius Rayon de l'arc peut etre négatif pour faire un dessin inverse (RayonCintrage)
     * @param length Longueur de l'arc
     * @param direction Direction à lasquel commence l'arc
     */
    drawArc(radius: number, length: number, direction: number) {
        // Verification si le signe du rayon & longeur ne sont pas inversé
        if (length < 0 && radius > 0) {
            length = Math.abs(length);
            radius = 0 - radius;
        }
        if (radius > 0) { // Si l'arc est positif
            // Toujour ajouter l'angle de la phase avant de continuer
            this.mCurrentDirection += direction;

            // Trouver le centre du cercle, decalage de +90° par rapport au début du tracer
            const circleCenterXy: Point2D = this.getPointFromAnglePath(this.mCurrent.X, this.mCurrent.Y, radius, this.mCurrentDirection + 90);

            // Calcule de l'angle de l'arc
            const arcAngle: number = this.radiansToDegrees(length / radius);

            // On trouve le point d'arriver de l'arc
            const endOfArc: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, radius, (this.mCurrentDirection - 90) + arcAngle);

            let angleDebutArc: number = (this.mCurrentDirection - 90);
            const angleFinArc: number = (this.mCurrentDirection - 90) + arcAngle;

            if (angleFinArc >= 0) {
                while (angleDebutArc < angleFinArc) {
                  // tslint:disable-next-line:no-shadowed-variable
                    const xyFromAnglePath: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, radius, angleDebutArc);
                    this.lineToAndCalcBox(xyFromAnglePath.X, xyFromAnglePath.Y);
                    angleDebutArc += 10;
                }

                // Derniere line pour terminer l'arc
                const xyFromAnglePath: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, radius, angleFinArc);
                this.lineToAndCalcBox(xyFromAnglePath.X, xyFromAnglePath.Y);
            } else if (angleFinArc < 0 && angleDebutArc < 0) {
                while (angleDebutArc < angleFinArc) {
                  // tslint:disable-next-line:no-shadowed-variable
                    const xyFromAnglePath: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, Math.abs(radius), angleDebutArc);
                    this.lineToAndCalcBox(xyFromAnglePath.X, xyFromAnglePath.Y);
                    angleDebutArc += 15;
                }
                // Derniere line pour terminer l'arc
                const xyFromAnglePath: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, Math.abs(radius), angleDebutArc);
                this.lineToAndCalcBox(xyFromAnglePath.X, xyFromAnglePath.Y);
            }

            // Enregistrement de la position + direction à la fin du tracé
            this.mCurrent.X = endOfArc.X;
            this.mCurrent.Y = endOfArc.Y;
            this.mCurrentDirection += arcAngle;
        } else { // Si l'arc est negatif
            this.mCurrentDirection += direction; // Toujour ajouter l'angle de la phase avant de continuer
            // Trouver le centre du cercle
            const circleCenterXy: Point2D = this.getPointFromAnglePath(this.mCurrent.X, this.mCurrent.Y, Math.abs(radius), this.mCurrentDirection - 90);

            // Calcule de l'angle de l'arc
            const arcAngle: number = this.radiansToDegrees(length / radius);

            // On trouve le point d'arriver
            const endOfArc: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, Math.abs(radius), (this.mCurrentDirection + 90) + arcAngle);

            let angleDebutArc: number = (this.mCurrentDirection + 90);
            const angleFinArc: number = (this.mCurrentDirection + 90) + arcAngle;
            if (angleFinArc <= 0) {
                while (angleDebutArc > angleFinArc) {
                  // tslint:disable-next-line:no-shadowed-variable
                    const xyFromAnglePath: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, Math.abs(radius), angleDebutArc);
                    this.lineToAndCalcBox(xyFromAnglePath.X, xyFromAnglePath.Y);
                    angleDebutArc -= 15;
                }
                // Derniere line pour terminer l'arc
                const xyFromAnglePath: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, Math.abs(radius), angleFinArc);
                this.lineToAndCalcBox(xyFromAnglePath.X, xyFromAnglePath.Y);
            } else {
                while (angleDebutArc > angleFinArc) {
                  // tslint:disable-next-line:no-shadowed-variable
                    const xyFromAnglePath: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, Math.abs(radius), angleDebutArc);
                    this.lineToAndCalcBox(xyFromAnglePath.X, xyFromAnglePath.Y);
                    angleDebutArc -= 15;
                }
                // Derniere line pour terminer l'arc
                const xyFromAnglePath: Point2D = this.getPointFromAnglePath(circleCenterXy.X, circleCenterXy.Y, Math.abs(radius), angleDebutArc);
                this.lineToAndCalcBox(xyFromAnglePath.X, xyFromAnglePath.Y);
            }
            // Enregistrement de la position + direction à la fin du tracé
            this.mCurrent.X = endOfArc.X;
            this.mCurrent.Y = endOfArc.Y;
            this.mCurrentDirection += arcAngle;
        }
    }

    private lineToAndCalcBox(x: number, y: number) {
        this.mPath.lineTo(x, y);
        if (x > this.maxWidth)
            this.maxWidth = x;
        if (x < this.minWidth)
            this.minWidth = x;
        if (y > this.maxHeight)
            this.maxHeight = y;
        if (y < this.minHeight)
            this.minHeight = y;
    }

    getPath(): Path2D {
        return this.mPath;
    }

    getPointFromAnglePath(x: number, y: number, distance: number, angle: number): Point2D {
        return new Point2D(x + distance * Math.cos(this.degreesToRadians(angle)),
                           y + distance * Math.sin(this.degreesToRadians(angle)));
    }

    public drawAndResizeCanvas(canvasContext: CanvasRenderingContext2D, canvasWidth: number, canvasHeight: number) {
        // Pour debug rectangle de la forme
        function DEBUGgetTrueMin(min: number, max: number) {
            let trueMinValue = 0;
            if (min < 0 && max < 0) {
                trueMinValue = max;
            } else if (min < 0 && max >= 0) {
                trueMinValue = min;
            } else if (min >= 0 && max < 0) {
                trueMinValue = 0; // Ne devrais jamais arrivé
            } else { // Min & max > 0
                trueMinValue = min;
            }
            return trueMinValue;
        }

        /**
         * Permet de calculer la heuteur et largeur du nuage de point
         * @param min valeur min de la box
         * @param max valeur max de la box
         * @returns difference entre les deux valeur
         */
        function getBoxValue(min: number, max: number): number {
            let boxValue = 0;
            if (min < 0 && max < 0) {
                boxValue = min - max - max;
            } else if (min < 0 && max >= 0) {
                boxValue = Math.abs(min) + max;
            } else if (min >= 0 && max < 0) {
                boxValue = 0; // Ne devrais jamais arrivé
                console.error('Impossible de calculer la box de la forme 99');
            } else { // Min & max > 0
                boxValue = max - min - min;
            }
            return boxValue;
        }

        // Calcul pour connnaitre le déplacement a faire pour replacer la forme en 0:0
        function getTranslate(min: number, max: number): number {
            let translateValue = 0;
            if (min < 0 && max < 0) {
                translateValue = Math.abs(max);
            } else if (min < 0 && max >= 0) {
                translateValue = Math.abs(min);
            } else if (min >= 0 && max < 0) {
                translateValue = 0; // Ne devrais jamais arrivé
                console.error('Impossible de calculer la box de la forme 99');
            } else { // Min & max > 0
                translateValue = 0 - min;
            }
            return translateValue;
        }

        function calcScaleValue(pathValue: number, canvasValue: number): number {
            return Math.min(1, (canvasValue * 1 / pathValue));
        }

      // tslint:disable-next-line:no-shadowed-variable
        function calcScaleXY(pathWidth: number, pathHeight: number, canvasWidth: number, canvasHeight: number): number {
            let maxLengthPath = 0;
            let maxLengthCanvasForPath = 0;
            if (pathWidth > pathHeight) {
                maxLengthPath = pathWidth;
                maxLengthCanvasForPath = canvasWidth;
            } else {
                maxLengthPath = pathHeight;
                maxLengthCanvasForPath = canvasHeight;
            }
            // Produit en croix pour avoir le scale factor
            const factorXY = (maxLengthCanvasForPath * 1 / maxLengthPath);
            return Math.min(1, factorXY);
        }

        // Calcul de la haute et de la largeur du dessin
        const boxWidth = getBoxValue(this.minWidth, this.maxWidth);
        const boxHeight = getBoxValue(this.minHeight, this.maxHeight);

        // Calcul du déplacement en 0;0 du dessin
        let translateX = getTranslate(this.minWidth, this.maxWidth);
        let translateY = getTranslate(this.minHeight, this.maxHeight);

        // Calcul du ration de l'image max 1
        const scaleXY = calcScaleXY(boxWidth, boxHeight, canvasWidth, canvasHeight);

        // Application du scale
        //boxWidth *= scaleXY;
        //boxHeight *= scaleXY;

        // Calcul pour centrer le dessin au millieu du schema
        translateX = (translateX + (canvasWidth / 2) - (boxWidth / 2));
        translateY = (translateY + (canvasHeight / 2) - (boxHeight / 2));

        // Deplacement
        canvasContext.translate(translateX, translateY);
        // Mise à l'echelle
        canvasContext.scale(scaleXY, scaleXY);

        // Resulat des calcul pour debug
        //console.log(`Canvas (X:Y) = (${width} : ${height})`);
        //console.log(`min and max X ${this.minWidth} - ${this.maxWidth}` );
        //console.log(`min and max Y ${this.minHeight} - ${this.maxHeight}`);
        //console.log(`path width and height = (${boxWidth} : ${boxHeight})`);
        //console.log(`translation (X:Y) = (${translateX} : ${translateY})`);
        console.log(`Scale XY= ${scaleXY}`);

        // Dessin de la forme
        // Sauvegarde des valeur du canvas
        const oldStrockStyle = canvasContext.strokeStyle;
        const oldShadowOffsetX = canvasContext.shadowOffsetX;
        const oldShadowOffsetY = canvasContext.shadowOffsetY;
        const oldShadowColor = canvasContext.shadowColor;
        const oldShadowBlur = canvasContext.shadowBlur;
        // Valeur arbitraire
        canvasContext.shadowOffsetX = 2;
        canvasContext.shadowOffsetY = 2;
        canvasContext.shadowColor = '#696969';
        canvasContext.shadowBlur = 5;
        canvasContext.lineWidth = this.mSteelDiameter;
        canvasContext.strokeStyle = '#4a79d9';            // Bleu d'armaor

        // Dessin de la forme
        canvasContext.stroke(this.mPath);
        // Pour debug dessin du contour de la forme
        canvasContext.lineWidth = 2;
        canvasContext.strokeStyle = 'black';
        canvasContext.strokeRect(DEBUGgetTrueMin(this.minWidth, this.maxHeight), DEBUGgetTrueMin(this.minHeight, this.minWidth), boxWidth, boxHeight);

        // Restore des valeurs du canvas
        canvasContext.strokeStyle = oldStrockStyle;
        canvasContext.shadowOffsetX = oldShadowOffsetX;
        canvasContext.shadowOffsetY = oldShadowOffsetY;
        canvasContext.shadowColor = oldShadowColor;
        canvasContext.shadowBlur = oldShadowBlur;
    }

    degreesToRadians(degrees: number): number {
        return degrees * (Math.PI / 180);
    }

    radiansToDegrees(radians: number): number {
        return radians * (180 / Math.PI);
    }
}

// Correspont a l'input à afficher
/**
 * Propre à angular
 * Contiens les info pour placer un input sur
 * le html avec la correspondance avec la ligne
 *
 * Id:      Id pour liaisont au tableau de valeur de cote dans CLineDec
 * X:       ...
 * Y:       ...
 * Width:   ...
 * Height:  ...
 * visible: Si l'input est visible ou non dans le html
 *
 */
export interface IInputCotation {
    Id: number;
    X: number;
    Y: number;
    Width: number;
    Height: number;
    visible: boolean;
    writable: boolean;
}

/**
 * Const correspondant au type de cote utilisée dans armaor
 */
const CST_TYPE_COTE = {
    tcUNDEF: 0,            //0
    tcN_EXISTE_PLUS: 1,    //1 anciennement grand cadre, supprimé dans update Version645
    tcPETITCADRE: 2,       //2
    tcCOTEVERTICALE: 3,    //3
    tcCOTEHORIZONTALE: 4,  //4
    tcN_EXISTE_PLUS_2: 5,  //5 anciennement grand angle, supprimé dans update Version645
    tcPETITCADREANGLE: 6,  //6
    tcDIAMETRE: 7,         //7
    tcNOMBRE: 8,           //8
    tcANGLE: 9,            //9
    tcLONGUEUR: 10,        //10
    tcCOTE: 11,            //11
    tcSPIRE: 12,           //12
    tcRAYON: 13,           //13
    tcCOTEOBLIQUE: 14,     //14
    tcDOUBLE: 15,          //15
    tcSPACER: 16,          //16
    tcRING: 17            //17
};

/**
 * Const correspondant au tpe de trance utilisé dans armaor
 */
const ITypeTrace = {
    ttUNDEF: 0,
    ttLIGNE: 1,
    ttLIGNECONTINUE: 2,
    ttRETOURBASGAUCHE: 3,
    ttRETOURBASDROIT: 4,
    ttRETOURHAUTGAUCHE: 5,
    ttRETOURHAUTDROIT: 6,
    ttEPINGLEBASGAUCHE: 7,
    ttEPINGLEBASDROIT: 8,
    ttEPINGLEHAUTGAUCHE: 9,
    ttEPINGLEHAUTDROIT: 10,
    ttCOURBEHAUT: 11,
    ttCOURBEBAS: 12,
    ttCERCLE: 13,
    ttARCCERCLE: 14,
    ttDELETETRACE: 15,
    ttRETOUROBLIQUE: 16,
    ttCOURBEGAUCHE: 17,
    ttCOURBEDROITE: 18,
    ttCOMMENTAIRE: 19
};
